import { useCallback } from 'react';
import Button from '@App/components/Button/Button';
import theme from '@css/theme.style.json';

import { useFormFactorOptions } from '@App/pages/Map/Sidepanel/sidepanel.utils';

import './vehicle-type-select.styl';

function VehicleTypeSelect(props) {
  const { vehicleTypes = [], setVehicleTypes, availablevVehicleTypes } = props;
  const formFactorOptions = useFormFactorOptions();

  const onClick = useCallback((type) => {
    if (vehicleTypes.includes(type)) {
      const newVehiclesTypes = vehicleTypes.filter(t => t !== type);
      setVehicleTypes(newVehiclesTypes);
    } else {
      setVehicleTypes([...vehicleTypes, type]);
    }
  }, [vehicleTypes, setVehicleTypes]);

  return (
    <div className="transport-type-select">
      {availablevVehicleTypes.includes('car') && (
        <div className="transport-type-select__option">
          <Button 
            icon="/img/icons/vehicle-types/car.svg"
            iconSize="25px"
            className="transport-type-select__option__button"
            layout="ghost"
            hover={false}
            onClick={() => onClick('car')}
            rootElProps={{ title: formFactorOptions.find(ff => ff.id === 'car')?.label }}
            css={{
              svg: {
                fill: vehicleTypes.includes('car') ? theme.color.black : theme.color.grey,
              },
              '&:before': {
                backgroundColor: `${!vehicleTypes.includes('car') && theme.color.grey} !important`,
              },
            }}
          />
        </div>
      )}
      {availablevVehicleTypes.includes('bicycle') && (
        <div className="transport-type-select__option">
          <Button 
            icon="/img/icons/vehicle-types/bicycle.svg" 
            iconSize="28px"
            className="transport-type-select__option__button"
            layout="ghost"
            hover={false}
            onClick={() => onClick('bicycle')}
            rootElProps={{ title: formFactorOptions.find(ff => ff.id === 'bicycle')?.label }}
            css={{
              svg: {
                fill: vehicleTypes.includes('bicycle') ? theme.color.black : theme.color.grey,
              },
              '&:before': {
                backgroundColor: `${!vehicleTypes.includes('bicycle') && theme.color.grey} !important`,
              },
            }}
          />
        </div>
      )}
      {availablevVehicleTypes.includes('cargo_bicycle') && (
        <div className="transport-type-select__option">
          <Button 
            icon="/img/icons/vehicle-types/cargo_bicycle.svg"
            iconSize="35px"
            className="transport-type-select__option__button"
            layout="ghost"
            hover={false}
            onClick={() => onClick('cargo_bicycle')}
            rootElProps={{ title: formFactorOptions.find(ff => ff.id === 'cargo_bicycle')?.label }}
            css={{
              svg: {
                fill: vehicleTypes.includes('cargo_bicycle') ? theme.color.black : theme.color.grey,
              },
              '&:before': {
                backgroundColor: `${!vehicleTypes.includes('cargo_bicycle') && theme.color.grey} !important`,
              },
            }}
          />
        </div>
      )}
      {availablevVehicleTypes.includes('scooter') && (
        <div className="transport-type-select__option">
          <Button 
            icon="/img/icons/vehicle-types/scooter.svg"
            iconSize="20px"
            className="transport-type-select__option__button"
            layout="ghost"
            hover={false}
            onClick={() => onClick('scooter')}
            rootElProps={{ title: formFactorOptions.find(ff => ff.id === 'scooter')?.label }}
            css={{
              svg: {
                fill: vehicleTypes.includes('scooter') ? theme.color.black : theme.color.grey,
              },
              '&:before': {
                backgroundColor: `${!vehicleTypes.includes('scooter') && theme.color.grey} !important`,
              },
            }}
          />
        </div>
      )}
      {availablevVehicleTypes.includes('moped') && (
        <div className="transport-type-select__option">
          <Button 
            icon="/img/icons/vehicle-types/moped.svg"
            iconSize="25px"
            className="transport-type-select__option__button"
            layout="ghost"
            hover={false}
            onClick={() => onClick('moped')}
            rootElProps={{ title: formFactorOptions.find(ff => ff.id === 'moped')?.label }}
            css={{
              svg: {
                fill: vehicleTypes.includes('moped') ? theme.color.black : theme.color.grey,
              },
              '&:before': {
                backgroundColor: `${!vehicleTypes.includes('moped') && theme.color.grey} !important`,
              },
            }}
          />
        </div>
      )}
    </div>
  );
}

export default VehicleTypeSelect;
